import { Link } from "react-router-dom";
import { categories } from "@/mocks/events";
import usePageMeta from "@/hooks/usePageMeta";

const values = [
  { icon: "ri-time-line", title: "实时更新", desc: "赛程与赛果全天候同步，保证你第一时间看到最新动态。" },
  { icon: "ri-stack-line", title: "多项目覆盖", desc: "从篮球、足球到电竞、赛车，覆盖面广泛的竞技项目资讯。" },
  { icon: "ri-shield-check-line", title: "信息准确", desc: "来源清晰、结构规范，减少信息噪音，专注比赛本身。" },
  { icon: "ri-smartphone-line", title: "多端友好", desc: "PC 与手机端均为舒适阅读体验，随时随地查看赛事。" },
];

const team = [
  { name: "赛事编辑组", role: "赛程与赛果维护", icon: "ri-edit-2-line" },
  { name: "内容报道组", role: "新闻与专题撰写", icon: "ri-newspaper-line" },
  { name: "产品技术组", role: "网站体验与数据", icon: "ri-code-s-slash-line" },
  { name: "用户支持组", role: "反馈与建议处理", icon: "ri-customer-service-2-line" },
];

const milestones = [
  { year: "2023", text: "51每日大赛正式上线，首批覆盖三大竞技项目。" },
  { year: "2024", text: "新增电竞与赛车板块，日均赛事资讯量翻倍。" },
  { year: "2025", text: "上线专题推荐与赛果汇总模块，完善移动端体验。" },
  { year: "2026", text: "全面升级门户版式，覆盖七大竞技项目赛事。" },
];

export default function About() {
  usePageMeta(
    "关于我们 - 51每日大赛",
    "了解 51每日大赛的定位、使命与团队背景。我们专注每日赛事资讯整合，覆盖各类竞技项目的赛程与比赛结果。",
    "关于我们,51每日大赛,赛事资讯,团队介绍",
  );
  return (
    <div className="w-full">
      <div className="w-full bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-8 py-8 md:py-10">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">关于我们</span>
          </nav>
          <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">关于我们</h1>
          <p className="mt-2 text-sm text-foreground-600 max-w-3xl leading-relaxed">
            了解 51每日大赛的定位、使命与团队背景。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-1.5 h-4 rounded-full bg-primary-500" />
              <span className="font-label text-xs tracking-[0.2em] uppercase text-primary-600">Our Mission</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-tight">
              让每一场比赛的资讯都触手可及
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              51每日大赛专注于每日赛事资讯的整合与呈现。我们希望用清晰的信息层级、及时的结果更新和丰富的内容板块，
              让每一位关注赛事的人都能快速了解当天正在进行和即将举行的比赛，掌握最新比赛结果与相关赛事动态。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
              我们的核心用户包括体育爱好者、赛事关注者、体育从业人员及相关媒体。围绕他们的真实需求，
              网站持续优化赛事浏览、筛选与检索体验。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <Link
                to="/events"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览赛事 <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                联系我们
              </Link>
            </div>
          </div>
          <div className="rounded-lg overflow-hidden border border-background-200 h-72 md:h-96">
            <img
              src="https://readdy.ai/api/search-image?query=wide%20view%20of%20modern%20sports%20stadium%20interior%20with%20green%20field%20and%20empty%20seats%20bright%20daylight%20clean%20editorial%20photography&width=1200&height=900&seq=about-hero-01&orientation=landscape"
              alt="51每日大赛赛事资讯"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {[
            { value: "7", label: "竞技项目覆盖" },
            { value: "500+", label: "每日赛事资讯" },
            { value: "24h", label: "赛果实时更新" },
            { value: "3", label: "端内一致体验" },
          ].map((s) => (
            <div key={s.label} className="rounded-lg border border-background-200 bg-background-50 p-5 text-center">
              <div className="font-heading text-3xl text-primary-600">{s.value}</div>
              <div className="text-xs text-foreground-600 mt-2">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-6">我们坚持的事</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center mb-4">
                  <i className={`${v.icon} text-xl`} />
                </span>
                <h3 className="font-heading text-base text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-6">发展历程</h2>
            <div className="relative pl-6">
              <div className="absolute left-[5px] top-2 bottom-2 w-px bg-background-200" />
              {milestones.map((m) => (
                <div key={m.year} className="relative mb-6 last:mb-0">
                  <span className="absolute -left-6 top-1 w-2.5 h-2.5 rounded-full bg-primary-500" />
                  <div className="font-heading text-sm text-primary-600">{m.year}</div>
                  <p className="text-sm text-foreground-700 mt-1">{m.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-6">团队构成</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {team.map((t) => (
                <div key={t.name} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center mb-3">
                    <i className={`${t.icon} text-lg`} />
                  </span>
                  <h3 className="font-heading text-base text-foreground-950">{t.name}</h3>
                  <p className="text-xs text-foreground-600 mt-1">{t.role}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-6">我们覆盖的项目</h2>
          <div className="flex flex-wrap gap-3">
            {categories.map((c) => (
              <Link
                key={c.id}
                to={`/category/${c.id}`}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className={`${c.icon} text-primary-500`} /> {c.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}